import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { DashboardLayoutComponent } from './layouts/dashboard-layout/dashboard-layout.component';
import { SessionLayoutComponent } from './layouts/session-layout/session-layout.component';
import { FieldTypesPageComponent } from './pages/dashboard/catalogues/field-types/field-types-page.component';
import { PrefillPageComponent } from './pages/dashboard/catalogues/prefills/prefill/prefill-page.component';
import { PrefillsPageComponent } from './pages/dashboard/catalogues/prefills/prefills-page.component';
import { TemplatePageComponent } from './pages/dashboard/catalogues/templates/template/template-page.component';
import { TemplatesPageComponent } from './pages/dashboard/catalogues/templates/templates-page.component';
import { DashboardPageComponent } from './pages/dashboard/dashboard-page.component';
import { SessionsPageComponent } from './pages/dashboard/sessions/sessions-page.component';
import { UserPageComponent } from './pages/dashboard/users/user/user-page.component';
import { UsersPageComponent } from './pages/dashboard/users/users-page.component';
import { LogInPageComponent } from './pages/log-in/log-in-page.component';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'login' },
  {
    path: '',
    component: SessionLayoutComponent,
    children: [{ path: 'login', component: LogInPageComponent, title: 'Iniciar sesión' }],
  },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    canActivate: [authGuard],
    children: [
      { path: '', component: DashboardPageComponent, title: 'Dashboard' },
      { path: 'users', component: UsersPageComponent, title: 'Usuarios' },
      { path: 'users/:uid', component: UserPageComponent, title: 'Detalle de usuario' },
      { path: 'sessions', component: SessionsPageComponent, title: 'Sesiones' },
      {
        path: 'catalogues/field-types',
        component: FieldTypesPageComponent,
        title: 'Tipos de campo',
      },
      {
        path: 'catalogues/templates',
        component: TemplatesPageComponent,
        title: 'Plantillas',
      },
      {
        path: 'catalogues/templates/:templateId',
        component: TemplatePageComponent,
        title: 'Detalle de plantilla',
      },
      // Los prerellenados tienen ruta propia (catalogo aparte, con su ficha de
      // detalle): ahi se crean y editan el prerellenado, sus valores y a que
      // campo pertenece cada uno (`components/prefill-value-modal`). El modal
      // de edicion de un campo de plantilla ya NO administra prerellenados.
      {
        path: 'catalogues/prefills',
        component: PrefillsPageComponent,
        title: 'Prerellenados',
      },
      {
        path: 'catalogues/prefills/:prefillId',
        component: PrefillPageComponent,
        title: 'Detalle de prerellenado',
      },
    ],
  },
  { path: '**', redirectTo: 'login' },
];
